const swea = require('swea');
const ViewerManager = swea.editor.ViewerManager;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;

class CustomCreateAnnotationInteraction extends swea.editor.interactions.CreateAnnotationInteraction {
  /**
   * Initializes the interaction.
   * @param element the element that the interaction listens to.
   * @param viewerId the viewer id of the viewer the interaction operates in.
   */
  initialize(element, viewerId){
    this.element = element;
    super.initialize(element, viewerId);
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ESC],
      this,
      () => {
        this.terminate();
      })
    );
  }

  /**
   * Sets the correct cursor when the interaction is initialized.
   * @override
   */
  whenInitialized(element, viewerId){
    super.whenInitialized();
    element;
    ViewerManager.instance().getViewerById(viewerId).setCursor('crosshair');
    InstructionServiceActions.showInstruction('instructions.create_annotation');
  }

  /**
   * Sets default cursor and hides instruction.
   * @override
   */
  whenTerminated(element, viewerId){
    super.whenTerminated();
    element;
    ViewerManager.instance().getViewerById(viewerId).setCursor('default');
    InstructionServiceActions.hideInstruction();
  }

}

export default CustomCreateAnnotationInteraction;
